import { render } from "./SignatureField.vue?vue&type=template&id=1678819e&scoped=true&ts=true"
import script from "./SignatureField.vue?vue&type=script&lang=ts"
export * from "./SignatureField.vue?vue&type=script&lang=ts"

import "./SignatureField.vue?vue&type=style&index=0&id=1678819e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1678819e"]])

export default __exports__